<template>
    <div class="online-cargo">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="onlineCargoQuery"
            pageID="onlineCargo"
            @edit-btn="editBtn"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn">
            </div>
            <div slot="table-module-btn">
              <reportExport #default="{ submit }" reportCode="REPORT_OTP_FRIGHT">
                  <el-tooltip effect="dark" content="导出" placement="bottom">
                      <span>
                          <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                      </span>
                  </el-tooltip>
              </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="againClick">重新推送</el-button>
            </div>
        </m-pane>
        <edit-dialog
            v-if="visiableDialog"
            :label-position="labelPosition"
            :visiableDialog.sync="visiableDialog"
            :data="dataObj"
            @handleClose="handleClose"
            @saveOk="saveOk">
        </edit-dialog>
    </div>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import _ from '@/components/lots/utils';
import formatTime from '@/utils/common.js';
import EditDialog from './Edit';
import reportExport from '@/components/lots/reportExportPlugin';
import { getLists, getAgainLists } from '../../../../api/vehicleFreePlatform';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    components: { mPane, EditDialog, reportExport },
    data () {
        return {
            selected: [],
            searchDataLists: {
                pageNo: 1,
                pageSize: 10,
                noCarCarrierType: '40'
            },
            config,
            pageTotal: 0,
            totalData: [],
            loading: false,
            visiableDialog: false,
            labelPosition: 'right',
            dataObj: {},
            isFirstSearch: true
        };
    },
    methods: {
        selectChange(data) {
            this.selected = data;
        },
        async getList() {
            const dict = await dictWithUrl('S_F_FLAG');
            const dictData = dict.data;
            this.loading = true;
            getLists(this.searchDataLists).then(res => {
                this.loading = false;
                if (res) {
                    this.totalData = (res.data.list || []).map(item => {
                        item.statusText = dictData.S_F_FLAG[item.status] || item.status;
                        if (item.status === 'SUCCESS') item.hiddenEvent = [ 'edit' ];
                        this.$set(item, 'senderAddr', [item.senderProvinceName || '-', item.senderCityName || '-', item.senderDistrictName || '-'].join(' / '));
                        this.$set(item, 'receiverAddr', [item.receiverProvinceName || '-', item.receiverCityName || '-', item.receiverDistrictName || '-'].join(' / '));
                        return { ...item };
                    });
                    this.pageTotal = res.data.totalCount;
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        searchChange(data) {
            if (!(data.dispatchNo || data.createTime)) {
                return this.$message.warning('发车单号 和 创建时间 不可同时为空');
            }
            if (_.isArray(data.createTime) && data.createTime.length) {
                if (new Date(data.createTime[1]).getTime() - new Date(data.createTime[0]).getTime() > 63 * 24 * 60 * 60 * 1000) {
                    return this.$message.warning('只有时间查询条件时，查询时间跨度不可超过两个月！');
                }
            }
            data.beginDate = (data.createTime && formatTime.formatDateTime(data.createTime[0])) || '';
            data.endDate = (data.createTime && formatTime.formatDateTime(data.createTime[1])) || '';
            this.searchDataLists = {
                ...this.searchDataLists,
                ...data,
                pageNo: 1
            };
            delete this.searchDataLists.createTime;
            this.isFirstSearch = false;
            this.getList();
        },
        pageChange(data) {
            this.searchDataLists.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            this.searchDataLists.pageSize = data;
            this.searchDataLists.pageNo = 1;
            this.getList();
        },
        editBtn(data) {
            this.dataObj = _.clone(data);
            this.$set(this.dataObj, 'senderAddr', [data.senderProvinceCode, data.senderCityCode, data.senderDistrictCode].filter(i => i));
            this.$set(this.dataObj, 'receiverAddr', [data.receiverProvinceCode, data.receiverCityCode, data.receiverDistrictCode].filter(i => i));
            this.dispatchNo = data.dispatchNo;
            this.visiableDialog = true;
        },
        saveOk(data) {
            if (data) {
                this.visiableDialog = false;
                this.getList();
            }
        },
        handleClose() {
            this.visiableDialog = false;
        },
        againClick() {
            if (this.selected.length === 0) {
                return this.$message.warning('至少选择一条数据');
            } else if (this.selected.length > 20) {
                return this.$message.warning('最多只能选择20条数据');
            }
            for (let index = 0; index < this.selected.length; index++) {
                if (this.selected[index].status === 'SUCCESS') {
                    return this.$message.warning('成功状态下不能再次推送');
                }
            }
            const arr = [];
            this.selected.forEach(item => {
                arr.push({ dispatchNo: item.dispatchNo, status: item.status });
            });
            getAgainLists(arr).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('重新推送成功');
                }
                this.getList();
            });
        },
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchDataLists,
                tenantCode: 'BLANK'
            });
        }
    }
};
</script>
